export default __webpack_public_path__ + "static/media/top-b-8-med.b007fdc9.jpg";